import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  // scroll to top in /middleware/pageChangeScroll.global.ts
};
